/**
 * NgwEditor 전역 라이선스 키 등록.
 *
 * `@ngweditor/react` 는 Editor 마운트 시 `resolveLicenseKey(options.licenseKey) ?? getLicenseKey()`
 * 로 키를 해석한다. 즉 각 `<Editor>` prop 에 licenseKey 를 넘기지 않아도, 이 모듈이 부팅 시점에
 * 등록한 전역 키로 fallback 된다. 따라서 어댑터의 Editor 렌더 경로(NgwEditorLifecycle) 가
 * 본 모듈을 side-effect import 하기만 하면 모든 에디터 인스턴스에 일괄 적용된다.
 *
 * 키 payload: product=ngweditor, domain=internal, expires=2099-12-31, plan=full, internal=true.
 */
import { setLicenseKey } from '@ngweditor/react'

const NGW_LICENSE_KEY =
  'NGW-eyJwcm9kdWN0Ijoibmd3ZWRpdG9yIiwiZG9tYWluIjoiaW50ZXJuYWwiLCJleHBpcmVzIjoiMjA5OS0xMi0zMSIsInBsYW4iOiJmdWxsIiwiaW50ZXJuYWwiOnRydWUsInNuIjoiN2Q3NzQxNDNjMTc4In0.p43qf5ryn2eUV7zw-_KLyDiyQ0TssR28pFQlwZmK7N82h7_HgK2LOlb7zl4AcahFUeuImVxqdCsw0xJTa58lCA'

setLicenseKey(NGW_LICENSE_KEY)
